<div
  *ngIf="open"
  class="mobile-location-dock"
  [class.mobile-location-dock--inline]="inlineWithControls"
  (click)="$event.stopPropagation()"
  (touchstart)="$event.stopPropagation()">
  <div class="mobile-location-dock__pill">
    <div class="svg-wrap">
      <img src="./assets/images/ic-location.svg" alt="Icon">
    </div>
    <app-location-search
      #dockLocationSearch
      (locationSelected)="locationSelected.emit($event)"
      (locationInputChanged)="locationInputChanged.emit($event)"
      [isClear]="isClear"
      [selectedAddress]="selectedAddress">
    </app-location-search>
  </div>
  <!-- Projected filter pills remain visible while typing. -->
  <div class="mobile-location-dock__trailing">
    <ng-content></ng-content>
  </div>
</div>
